import { render } from "./Gallery.vue?vue&type=template&id=39e754e8&bindings={}"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"

import "./Gallery.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script